<template>
  <div
    class="t-table"
    :style="{
			'border-width': borderType === 'grid' ? '1px' : '0',
			'border-color': borderColor
		}"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    // 表格线颜色
    borderColor: {
      type: String,
      default: "#e4e4e4"
    },
    // 斑马纹颜色
    zebraColor: {
      type: String,
      default: "#f8f8f8"
    },
    // 网格线条样式： 网格grid 行状row 无none
    borderType: {
      type: String,
      default: "grid"
    },
    zebraStripe: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      table: this
    };
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.t-table {
  width: 100%;
  border: 1px #e4e4e4 solid;
  border-left: none;
  border-top: none;
  box-sizing: border-box;
}

.t-table >>> t-tr {
  display: flex;
}
/* #endif */
</style>